export default __webpack_public_path__ + "static/media/helmet0.82f0e675.svg";